import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import ProductCard from '../components/ProductCard';
import { API_URL } from '../config';

const API = API_URL;

const CAT_META = {
  phones:              { icon: '📱', color: '#cc0000' },
  glass:               { icon: '🔮', color: '#7c3aed' },
  speakers:            { icon: '🔊', color: '#0891b2' },
  playstation:         { icon: '🎮', color: '#16a34a' },
  earphones:           { icon: '🎧', color: '#db2777' },
  'phone-cases':       { icon: '📦', color: '#ea580c' },
  chargers:            { icon: '🔌', color: '#ca8a04' },
  smartwatches:        { icon: '⌚', color: '#0d9488' },
  powerbanks:          { icon: '🔋', color: '#2563eb' },
  'gaming-accessories':{ icon: '🖱️', color: '#9333ea' },
  accessories:         { icon: '🎙️', color: '#475569' },
};

const CategoryPage = () => {
  const { cat } = useParams();
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [sort, setSort]         = useState('');
  const meta = CAT_META[cat] || { icon: '⚡', color: '#cc0000' };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    axios.get(`${API}/products?category=${cat}${sort ? `&sort=${sort}` : ''}`)
      .then(r => setProducts(r.data.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [cat, sort]);

  const titleKey = `section_${cat.replace(/-/g, '_')}`;

  return (
    <div className="category-page">
      {/* Hero banner */}
      <div className="cat-banner" style={{ '--cat-color': meta.color }}>
        <div className="cat-banner__inner">
          <span className="cat-banner__icon">{meta.icon}</span>
          <div>
            <p className="cat-banner__sub">{t('browse')} Matrix</p>
            <h1 className="cat-banner__title">{t(titleKey) || cat}</h1>
            <p className="cat-banner__count">{products.length} {t('products_available')}</p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="breadcrumb__inner">
          <Link to="/">{t('nav_home')}</Link>
          <span>›</span>
          <span>{t(titleKey) || cat}</span>
        </div>
      </div>

      {/* Sort + results */}
      <div className="category-page__inner">
        <div className="category-page__toolbar">
          <p className="toolbar-count">{products.length} {t('results_found')}</p>
          <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
            <option value="">{t('sort_default')}</option>
            <option value="price_asc">{t('sort_price_asc')}</option>
            <option value="price_desc">{t('sort_price_desc')}</option>
            <option value="rating">{t('sort_rating')}</option>
          </select>
        </div>

        {loading ? (
          <div className="product-grid">
            {[...Array(8)].map((_, i) => <div key={i} className="skeleton-card" />)}
          </div>
        ) : products.length === 0 ? (
          <div className="no-results">
            <span>😕</span>
            <p>{t('no_results')}</p>
            <Link to="/" className="btn btn--primary">{t('back_home')}</Link>
          </div>
        ) : (
          <div className="product-grid">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
